var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",attrs:{"src":"/img/swiss.png","alt":"Swiss Money","title":"Swiss Money"}})
}
var staticRenderFns = []

export { render, staticRenderFns }